import React from "react";
import surveyPageDemoSteps from "./survey/surveyPageDemoSteps";
import goalsPageDemoSteps from "./survey/goalsPageDemoSteps";
import accountsPageDemoSteps from "./survey/accountsPageDemoSteps";
import homeValueDemoSteps from "./survey/homeValueDemoSteps";

const surveyConfigurations = {
  isCustomer: surveyPageDemoSteps,
  goals: goalsPageDemoSteps,
  currentAccounts: accountsPageDemoSteps,
  'home-value': homeValueDemoSteps
};

const getSurveyPageSteps = key => {
  const steps = surveyConfigurations?.[`${key}`] || [];
  return steps.map((step, index) => {
    return {
      ...step,
      id: step.id || `${key}.assistant.step-${index}`
    }
  })
};

export default getSurveyPageSteps;
